import { createSlice } from '@reduxjs/toolkit';

export const reportingSlice = createSlice({
	name: 'reporting',
	initialState: {},
	reducers: {
		resetSalesCommissionReportState: (state) => {
			state.invoiceCommissionList = undefined;
			state.invoiceCommissionListHeaders = undefined;

			state.invoiceCommissionDrillDownList = undefined;
			state.invoiceCommissionDrillDownListHeader = undefined;

			state.creditNoteCommissionList = undefined;
			state.creditNoteCommissionListHeaders = undefined;

			state.creditNoteCommissionDrillDownList = undefined;
			state.creditNoteCommissionDrillDownListHeader = undefined;
		},

		// Get Full Enabled Product Detail List
		getLevel1EnabledProductDetailList_request: (state) => {
			state.getLevel1EnabledProductDetailList_requesting = true;
			state.getLevel1EnabledProductDetailList_isSuccessful = undefined;
		},
		getLevel1EnabledProductDetailList_success: (state, action) => {
			state.getLevel1EnabledProductDetailList_requesting = false;
			state.getLevel1EnabledProductDetailList_isSuccessful = true;
			
			state.level1EnabledProductDetailList = action?.payload?.data;
		},
		getLevel1EnabledProductDetailList_failure: (state) => {
			state.getLevel1EnabledProductDetailList_requesting = false;
			state.getLevel1EnabledProductDetailList_isSuccessful = false;
		},

		// Add Product Level 1
		addProductLevel1_request: (state) => {
			state.addProductLevel1_requesting = true;
			state.addProductLevel1_isSuccessful = undefined;
		},
		addProductLevel1_success: (state) => {
			state.addProductLevel1_requesting = false;
			state.addProductLevel1_isSuccessful = true;
		},
		addProductLevel1_failure: (state) => {
			state.addProductLevel1_requesting = false;
			state.addProductLevel1_isSuccessful = false;
		},

		// Delete Product Level 1
		deleteProductLevel1_request: (state) => {
			state.deleteProductLevel1_requesting = true;
			state.deleteProductLevel1_isSuccessful = undefined;
		},
		deleteProductLevel1_success: (state) => {
			state.deleteProductLevel1_requesting = false;
			state.deleteProductLevel1_isSuccessful = true;
		},
		deleteProductLevel1_failure: (state) => {
			state.deleteProductLevel1_requesting = false;
			state.deleteProductLevel1_isSuccessful = false;
		},


		// Get Full Enabled Product Detail List
		getLevel2EnabledProductDetailList_request: (state) => {
			state.getLevel2EnabledProductDetailList_requesting = true;
			state.getLevel2EnabledProductDetailList_isSuccessful = undefined;
		},
		getLevel2EnabledProductDetailList_success: (state, action) => {
			state.getLevel2EnabledProductDetailList_requesting = false;
			state.getLevel2EnabledProductDetailList_isSuccessful = true;
			
			state.level2EnabledProductDetailList = action?.payload?.data;
		},
		getLevel2EnabledProductDetailList_failure: (state) => {
			state.getLevel2EnabledProductDetailList_requesting = false;
			state.getLevel2EnabledProductDetailList_isSuccessful = false;
		},

		// Get Level 2 Commission Percentage
		getLevel2CommissionPercentage_request: (state) => {
			state.getLevel2CommissionPercentage_requesting = true;
			state.getLevel2CommissionPercentage_isSuccessful = undefined;
		},
		getLevel2CommissionPercentage_success: (state, action) => {
			state.getLevel2CommissionPercentage_requesting = false;
			state.getLevel2CommissionPercentage_isSuccessful = true;
			
			state.level2CommissionPercentage = action?.payload?.data;
		},
		getLevel2CommissionPercentage_failure: (state) => {
			state.getLevel2CommissionPercentage_requesting = false;
			state.getLevel2CommissionPercentage_isSuccessful = false;
		},

		// Add Product Level 1
		addProductLevel2_request: (state) => {
			state.addProductLevel2_requesting = true;
			state.addProductLevel2_isSuccessful = undefined;
		},
		addProductLevel2_success: (state) => {
			state.addProductLevel2_requesting = false;
			state.addProductLevel2_isSuccessful = true;
		},
		addProductLevel2_failure: (state) => {
			state.addProductLevel2_requesting = false;
			state.addProductLevel2_isSuccessful = false;
		},

		// Delete Product Level 1
		deleteProductLevel2_request: (state) => {
			state.deleteProductLevel2_requesting = true;
			state.deleteProductLevel2_isSuccessful = undefined;
		},
		deleteProductLevel2_success: (state) => {
			state.deleteProductLevel2_requesting = false;
			state.deleteProductLevel2_isSuccessful = true;
		},
		deleteProductLevel2_failure: (state) => {
			state.deleteProductLevel2_requesting = false;
			state.deleteProductLevel2_isSuccessful = false;
		},

		// Update Level 2 Commission Percentage
		updateLevel2CommissionPercentage_request: (state) => {
			state.updateLevel2CommissionPercentage_requesting = true;
			state.updateLevel2CommissionPercentage_isSuccessful = undefined;
		},
		updateLevel2CommissionPercentage_success: (state) => {
			state.updateLevel2CommissionPercentage_requesting = false;
			state.updateLevel2CommissionPercentage_isSuccessful = true;
		},
		updateLevel2CommissionPercentage_failure: (state) => {
			state.updateLevel2CommissionPercentage_requesting = false;
			state.updateLevel2CommissionPercentage_isSuccessful = false;
		},


		// Get Invoice Commission List
		getInvoiceCommissionList_request: (state) => {
			state.getInvoiceCommissionList_requesting = true;
			state.getInvoiceCommissionList_isSuccessful = undefined;

			state.invoiceCommissionList = undefined;
			state.invoiceCommissionListHeaders = undefined;
		},
		getInvoiceCommissionList_success: (state, action) => {
			state.getInvoiceCommissionList_requesting = false;
			state.getInvoiceCommissionList_isSuccessful = true;
			
			let response = action?.payload?.response;
			state.invoiceCommissionList = response?.data;
			state.invoiceCommissionListHeaders = response?.headers;
			state.isInvoiceCommissionLevel1 = action?.payload?.level;
		},
		getInvoiceCommissionList_failure: (state) => {
			state.getInvoiceCommissionList_requesting = false;
			state.getInvoiceCommissionList_isSuccessful = false;
		},

		// Get Invoice Commission Drill Down List
		getInvoiceCommissionDrillDownList_request: (state) => {
			state.getInvoiceCommissionDrillDownList_requesting = true;
			state.getInvoiceCommissionDrillDownList_isSuccessful = undefined;
			state.invoiceCommissionDrillDownList = undefined;
			state.invoiceCommissionDrillDownListHeader = undefined;		
		},
		getInvoiceCommissionDrillDownList_success: (state, action) => {
			state.getInvoiceCommissionDrillDownList_requesting = false;
			state.getInvoiceCommissionDrillDownList_isSuccessful = true;
			
			let response = action?.payload?.response;
			state.invoiceCommissionDrillDownList = response?.data;
			state.invoiceCommissionDrillDownListHeader = response?.headers;
			state.isInvoiceCommissionDrillDownLevel1 = action?.payload?.level;
		},
		getInvoiceCommissionDrillDownList_failure: (state) => {
			state.getInvoiceCommissionDrillDownList_requesting = false;
			state.getInvoiceCommissionDrillDownList_isSuccessful = false;
		},

		// Get Credit Note Commission List
		getCreditNoteCommissionList_request: (state) => {
			state.getCreditNoteCommissionList_requesting = true;
			state.getCreditNoteCommissionList_isSuccessful = undefined;

			state.creditNoteCommissionList = undefined;
			state.creditNoteCommissionListHeaders = undefined;
		},
		getCreditNoteCommissionList_success: (state, action) => {
			state.getCreditNoteCommissionList_requesting = false;
			state.getCreditNoteCommissionList_isSuccessful = true;
			
			let response = action?.payload?.response;
			state.creditNoteCommissionList = response?.data;
			state.creditNoteCommissionListHeaders = response?.headers;
			state.isCreditNoteCommissionLevel1 = action?.payload?.level;
		},
		getCreditNoteCommissionList_failure: (state) => {
			state.getCreditNoteCommissionList_requesting = false;
			state.getCreditNoteCommissionList_isSuccessful = false;
		},

		// Get Credit Note Commission Drill Down List
		getCreditNoteCommissionDrillDownList_request: (state) => {
			state.getCreditNoteCommissionDrillDownList_requesting = true;
			state.getCreditNoteCommissionDrillDownList_isSuccessful = undefined;
			state.creditNoteCommissionDrillDownList = undefined;
			state.creditNoteCommissionDrillDownListHeader = undefined;
		},
		getCreditNoteCommissionDrillDownList_success: (state, action) => {
			state.getCreditNoteCommissionDrillDownList_requesting = false;
			state.getCreditNoteCommissionDrillDownList_isSuccessful = true;
			
			let response = action?.payload?.response;
			state.creditNoteCommissionDrillDownList = response?.data;
			state.creditNoteCommissionDrillDownListHeader = response?.headers;
			state.isCreditNoteCommissionDrillDownLevel1 = action?.payload?.level;
		},
		getCreditNoteCommissionDrillDownList_failure: (state) => {
			state.getCreditNoteCommissionDrillDownList_requesting = false;
			state.getCreditNoteCommissionDrillDownList_isSuccessful = false;
		},

		// Update Invoice Reporting Data
		updateInvoiceReportingData_request: (state) => {
			state.updateInvoiceReportingData_requesting = true;
			state.updateInvoiceReportingData_isSuccessful = undefined;
		},
		updateInvoiceReportingData_success: (state) => {
			state.updateInvoiceReportingData_requesting = false;
			state.updateInvoiceReportingData_isSuccessful = true;
		},
		updateInvoiceReportingData_failure: (state) => {
			state.updateInvoiceReportingData_requesting = false;
			state.updateInvoiceReportingData_isSuccessful = false;
		},

		// Update Credit Note Reporting Data
		updateCreditNoteReportingData_request: (state) => {
			state.updateCreditNoteReportingData_requesting = true;
			state.updateCreditNoteReportingData_isSuccessful = undefined;
		},
		updateCreditNoteReportingData_success: (state) => {
			state.updateCreditNoteReportingData_requesting = false;
			state.updateCreditNoteReportingData_isSuccessful = true;
		},
		updateCreditNoteReportingData_failure: (state) => {
			state.updateCreditNoteReportingData_requesting = false;
			state.updateCreditNoteReportingData_isSuccessful = false;
		},

		// Get POS Count Report
		getPOSCountReport_request: (state) => {
			state.getPOSCountReport_requesting = true;
			state.getPOSCountReport_isSuccessful = undefined;
			state.posCountReport = undefined;
			state.posCountReportHeader = undefined;		
		},
		getPOSCountReport_success: (state, action) => {
			state.getPOSCountReport_requesting = false;
			state.getPOSCountReport_isSuccessful = true;
			
			let response = action?.payload;
			state.posCountReport = response?.data;
			state.posCountReportHeader = response?.headers;
		},
		getPOSCountReport_failure: (state) => {
			state.getPOSCountReport_requesting = false;
			state.getPOSCountReport_isSuccessful = false;
		},
		
		// Get All POS Count Report
		getAllPOSCountReport_request: (state) => {
			state.getAllPOSCountReport_requesting = true;
			state.getAllPOSCountReport_isSuccessful = undefined;
			state.allPosCountReport = undefined;
			state.allPosCountReportHeader = undefined;		
		},
		getAllPOSCountReport_success: (state, action) => {
			state.getAllPOSCountReport_requesting = false;
			state.getAllPOSCountReport_isSuccessful = true;
			
			let response = action?.payload;
			state.allPosCountReport = response?.data;
			state.allPosCountReportHeader = response?.headers;
		},
		getAllPOSCountReport_failure: (state) => {
			state.getAllPOSCountReport_requesting = false;
			state.getAllPOSCountReport_isSuccessful = false;
		},

		// Get Billing Setup Report
		getBillingSetupReport_request: (state) => {
			state.getBillingSetupReport_requesting = true;
			state.getBillingSetupReport_isSuccessful = undefined;

			state.billingSetupReport = undefined;
		},
		getBillingSetupReport_success: (state, action) => {
			state.getBillingSetupReport_requesting = false;
			state.getBillingSetupReport_isSuccessful = true;

			state.billingSetupReport = action?.payload?.data;
		},
		getBillingSetupReport_failure: (state) => {
			state.getBillingSetupReport_requesting = false;
			state.getBillingSetupReport_isSuccessful = false;
		},

		// Get Trial COM Report
		getTrialCOMReport_request: (state) => {
			state.getTrialCOMReport_requesting = true;
			state.getTrialCOMReport_isSuccessful = undefined;

			state.trialCOMList = undefined;
			state.trialCOMListHeaders = undefined;
		},
		getTrialCOMReport_success: (state, action) => {
			state.getTrialCOMReport_requesting = false;
			state.getTrialCOMReport_isSuccessful = true;
			
			let response = action?.payload;
			state.trialCOMList = response?.data;
			state.trialCOMListHeaders = response?.headers;
		},
		getTrialCOMReport_failure: (state) => {
			state.getTrialCOMReport_requesting = false;
			state.getTrialCOMReport_isSuccessful = false;
		},

		// Get Store Report
		getStoreReport_request: (state) => {
			state.getStoreReport_requesting = true;
			state.getStoreReport_isSuccessful = undefined;

			state.storeReport = undefined;
			state.storeReportHeaders = undefined;
		},
		getStoreReport_success: (state, action) => {
			state.getStoreReport_requesting = false;
			state.getStoreReport_isSuccessful = true;
			
			let response = action?.payload;
			state.storeReport = response?.data;
			state.storeReportHeaders = response?.headers;
		},
		getStoreReport_failure: (state) => {
			state.getStoreReport_requesting = false;
			state.getStoreReport_isSuccessful = false;
		},

		// Get Store Report
		getFullStoreReport_request: (state) => {
			state.getFullStoreReport_requesting = true;
			state.getFullStoreReport_isSuccessful = undefined;

			state.fullStoreReport = undefined;
			state.fullStoreReportHeaders = undefined;
		},
		getFullStoreReport_success: (state, action) => {
			state.getFullStoreReport_requesting = false;
			state.getFullStoreReport_isSuccessful = true;
			
			let response = action?.payload;
			state.fullStoreReport = response?.data;
			state.fullStoreReportHeaders = response?.headers;
		},
		getFullStoreReport_failure: (state) => {
			state.getFullStoreReport_requesting = false;
			state.getFullStoreReport_isSuccessful = false;
		},

		// Get Activation Log Report
		getActivationLogReport_request: (state) => {
            state.getActivationLogReport_requesting = true;
            state.getActivationLogReport_isSuccessful = undefined;

            state.activationLogReportList = undefined;
            state.activationLogReportListHeaders = undefined;
        },
        getActivationLogReport_success: (state, action) => {
            state.getActivationLogReport_requesting = false;
            state.getActivationLogReport_isSuccessful = true;
            
            let response = action?.payload;
            state.activationLogReportList = response?.data;
            state.activationLogReportListHeaders = response?.headers;
        },
        getActivationLogReport_failure: (state) => {
            state.getActivationLogReport_requesting = false;
            state.getActivationLogReport_isSuccessful = false;
        },

        // Get API Usage Report
        getApiUsageReport_request: (state) => {
            state.getApiUsageReport_requesting = true;
            state.getApiUsageReport_isSuccessful = undefined;
        },
        getApiUsageReport_success: (state, action) => {
            state.getApiUsageReport_requesting = false;
            state.getApiUsageReport_isSuccessful = true;
            
            let response = action?.payload;
            state.apiUsageReportList = response?.data;
            state.apiUsageReportListHeaders = response?.headers;
        },
        getApiUsageReport_failure: (state) => {
            state.getApiUsageReport_requesting = false;
            state.getApiUsageReport_isSuccessful = false;
        },
	},
});

export const { 
	resetSalesCommissionReportState,

	getLevel1EnabledProductDetailList_request, getLevel1EnabledProductDetailList_success, getLevel1EnabledProductDetailList_failure,
	addProductLevel1_request, addProductLevel1_success, addProductLevel1_failure,
	deleteProductLevel1_request, deleteProductLevel1_success, deleteProductLevel1_failure,

	getLevel2EnabledProductDetailList_request, getLevel2EnabledProductDetailList_success, getLevel2EnabledProductDetailList_failure,
	getLevel2CommissionPercentage_request, getLevel2CommissionPercentage_success, getLevel2CommissionPercentage_failure,
	addProductLevel2_request, addProductLevel2_success, addProductLevel2_failure,
	deleteProductLevel2_request, deleteProductLevel2_success, deleteProductLevel2_failure,
	updateLevel2CommissionPercentage_request, updateLevel2CommissionPercentage_success, updateLevel2CommissionPercentage_failure,

	getInvoiceCommissionList_request, getInvoiceCommissionList_success, getInvoiceCommissionList_failure,
	getInvoiceCommissionDrillDownList_request, getInvoiceCommissionDrillDownList_success, getInvoiceCommissionDrillDownList_failure,

	getCreditNoteCommissionList_request, getCreditNoteCommissionList_success, getCreditNoteCommissionList_failure,
	getCreditNoteCommissionDrillDownList_request, getCreditNoteCommissionDrillDownList_success, getCreditNoteCommissionDrillDownList_failure,

	updateInvoiceReportingData_request, updateInvoiceReportingData_success, updateInvoiceReportingData_failure,
	updateCreditNoteReportingData_request, updateCreditNoteReportingData_success, updateCreditNoteReportingData_failure,

	getPOSCountReport_request, getPOSCountReport_success, getPOSCountReport_failure,
	getAllPOSCountReport_request, getAllPOSCountReport_success, getAllPOSCountReport_failure,
	getBillingSetupReport_request, getBillingSetupReport_success, getBillingSetupReport_failure,
	getTrialCOMReport_request, getTrialCOMReport_success, getTrialCOMReport_failure,
	getStoreReport_request, getStoreReport_success, getStoreReport_failure,
	getFullStoreReport_request, getFullStoreReport_success, getFullStoreReport_failure,

	getActivationLogReport_request, getActivationLogReport_success, getActivationLogReport_failure,
	getApiUsageReport_request, getApiUsageReport_success, getApiUsageReport_failure
} = reportingSlice.actions;

export default reportingSlice.reducer;